
function GetSuggestedProducts() {
    if ($("#CurCatalogID").length > 0 && $(".AutoGetSuggested").length > 0) {
        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetSuggestedProducts",
            data: "ProductID=" + $("#ProductID").val() + "&CurCatalogID=" + $("#CurCatalogID").val() + "&ColorID=" + $(".Colors .ColorOptionItem.active:first a").attr("data-id"),
            cache: false,
            success: function (dt) {
                dt = dt.replace("_buyuk", "_kucuk");
                $(".AutoGetSuggested .AutoSetted").remove();

                if (dt != "") {
                    $(".AutoGetSuggested").append(dt);
                    $(".AutoGetSuggested .Productsuggest .ProductList").addClass("col-xs-24");
                }
            }
        });
    }
}

function GetLastVisitedPrdView(productData) {
    if ($(".AutoGetLastVisited").length > 0) {
        $.ajax({
            type: "POST",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetLastVisitedProductsView",
            data: JSON.stringify(productData),
            //contentType:"text/html",
            contentType: 'application/json; charset=utf-8',
            cache: false,
            success: function (dt) {
                $(".LastViewedProducts.AutoSetted").remove();

                if (dt != "") {
                    $(".AutoGetLastVisited").append(dt);

                    if ($(".SuggestedProductsContainer .AutoGetLastVisited .SuggestedProducts .ProductList .Prd").length > 2 && $(window).width() < 992) {
                        SlickSlider(true);
                    }

                    $(".AutoGetLastVisited .SuggestedProducts .Prd img.UseLazyLoad").Lazy();
                }
            }
        });
    }
}

function SetLastVisitedProductsStorage() {
    var LastVisitedPrds = [];

    if (typeof (Storage) !== "undefined") {
        if ($(".ProductHeader:first").length > 0 || $(".AutoGetLastVisited").length > 0) {
            var hours = 8; // Reset when storage is more than 24hours
            var now = new Date().getTime();
            var setupTime = localStorage.getItem('prdLastSetupTime');

            if (setupTime == null) {
                localStorage.setItem('prdLastSetupTime', now);
            } else {
                if (now - setupTime > hours * 60 * 60 * 1000) {
                    localStorage.removeItem("LastVisitedPrds");
                    localStorage.setItem('prdLastSetupTime', now);
                }
            }

            var _productid = $("#ProductID:first").val();
            var _colorid = $("#ColorID:first").val();
            var _url = window.location.pathname;
            var _prdImg = $("#FirstAngle:first").val();//$("meta[property$=image]").attr("content");
            var _prdname = $(".ProductHeader:first").text();
            var _amount = $(".PriceItem:first").text();

            _prdname = _prdname.replace(/(\r\n|\n|\r)/gm, "").trim();

            LastVisitedPrds = localStorage.LastVisitedPrds;

            if (LastVisitedPrds == undefined) {
                LastVisitedPrds = [];
            } else {
                LastVisitedPrds = JSON.parse(LastVisitedPrds);
            }

            var itemExist = false;

            for (var i = 0; i < LastVisitedPrds.length; i++) {

                if (LastVisitedPrds[i].ColorID == _colorid && LastVisitedPrds[i].ProductID == _productid) {
                    itemExist = true;
                }
            }

            if (!itemExist) {

                LastVisitedPrds.push({ Amount: _amount, ProductID: _productid, ColorID: _colorid, Url: _url, Img1: _prdImg, Img2: _prdImg, ProductName: _prdname });

                if (LastVisitedPrds.length > 5) {
                    LastVisitedPrds.shift();
                }

                localStorage.LastVisitedPrds = JSON.stringify(LastVisitedPrds);
            }

            if (LastVisitedPrds != undefined && LastVisitedPrds.length > 0) {
                GetLastVisitedPrdView(LastVisitedPrds);
            }
        }
    }
    else {
        console.warn("Tarayıcının localstorage desteği bulunmuyor.");
    }
}

function SlickSlider(SuggestedSlick) {
    if ($("#NewPd").length > 0) {
        if (SuggestedSlick) {
            if ($(".SuggestedProductsContainer .SuggestedProducts .ProductList > .Prd").length >= 1 && $(window).width() < 992 && SuggestedSlick) {
                $(".SuggestedProductsContainer .SuggestedProducts .ProductList").slick({
                    nextArrow: "<div class='PrdImgRight right-arrow'><i class='sorsfont sorsfont-right-arrow'></i></div>",
                    prevArrow: "<div class='PrdImgLeft left-arrow'><i class='sorsfont sorsfont-left-arrow'></i></div>",
                    infinite: true,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: true,
                    responsive: [
                        {
                            breakpoint: 700,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                infinite: true,
                                dots: true
                            }
                        },
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 1,
                                infinite: true,
                                dots: true
                            }
                        }
                    ]
                });
            }
        }
        else {
            UseSliderObject = "";

            if ($("#NewPd").hasClass("Combines")) {
                UseSliderObject = $('.ProductDetailImages ul');
            }
            else {
                UseSliderObject = $('.ProductDetailsMainImage ul');
            }

            // Main Slider
            UseSliderObject.slick({
                nextArrow: "<div class='PrdImgRight right-arrow'><i class='sorsfont sorsfont-right-arrow'></i></div>",
                prevArrow: "<div class='PrdImgLeft left-arrow'><i class='sorsfont sorsfont-left-arrow'></i></div>",
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true
                , responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: true
                        }
                    }
                ]
            });

            // Small Product Slider
            if ($("#NewPd").hasClass("Combines")) {
                $('.SmallProductImages ul').slick({
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    asNavFor: UseSliderObject,
                    centerMode: true,
                    focusOnSelect: true,
                    vertical: false,
                    arrows: false
                });
            }
            else if ($(window).width() > 991) {
                $('.SmallProductImages ul').slick({
                    slidesToShow: 5,
                    slidesToScroll: 2,
                    asNavFor: UseSliderObject,
                    centerMode: true,
                    focusOnSelect: true,
                    vertical: true
                });
            }
        }
    }
}

// Loader
$(window).on('load', function () {
    setTimeout(function () {
        $(".preloader").fadeOut("fast");
    });

    // Video oynatma
    if ($("#video-product-detail").length > 0) {
        var videoPath = $("#video-product-detail").attr("data-src");
        var player = videojs('video-product-detail');

        player.ready(function () {
            this.src({
                src: videoPath,
                type: 'video/mp4'
            });

            player.play();
        });
    }
});

$(document).ready(function () {

    IsfollowForProductDetails();
    GetSuggestedProducts();
    SlickSlider(false);
    SetLastVisitedProductsStorage();

    //mobilde ürün açıklaması kapalı gelmesi istendi FS#13767
    if ($(window).width() < 991) {
        var aciklamaDiv = document.getElementById("aciklama");
        if (aciklamaDiv) {
            aciklamaDiv.classList.remove("show");

            var button = document.querySelector('button[data-target="#aciklama"]');
            button.classList.add("collapsed");
            button.setAttribute("aria-expanded", "false");
        }
    }

    // To Operations
    $('.PdInstallmentOptions, .PrInstallmentOptions').live("click", function (e) {

        var Amount = $(".PriceItem:first").html();

        Amount = Amount.replace(".", ",");

        GetProductInstalments(Amount);
    });

    //SEPETE EKLE
    $(".AddToBasket.ProductDetails #Basket").live("click", function (e) {

        var SizeID = $("#SizeID").val();
        var ColorID = $("#ColorID").val();
        var ProductID = $("#ProductID").val();
        var Amount = 1;
        var LangID = $("#LangID").val();
        //var BedenSec = $('#BedenSec').val();
        var RenkSec = $('#RenkSec').val();
        var UrunYok = $('#UrunYok').val();
        var UserName = $('#UserEmail').val();
        var Gsm = $('#UserPhone').val();
        var hashedEmail = $('#hashedEmail').val();
        var hashedGsm = $('#hashedGsm').val();
        var gender = $('#Gender').val();

        var PathUrl = $('#pvUrl').val();
        var pvUrl2 = $('#pvUrl2').val();

        var location = window.location.href;

        //console.log(gender);
        //console.log(UserName);
        //console.log(hashedEmail);

        $basketButton = $(this);

        var ProductCode = $basketButton.attr("data-productcode");
        var ColorCode = $(".ColorOptionItem.active > a").attr("data-code");

        var UserID = $('#UserID').val();
        var ProductName = $basketButton.attr("data-productname");
        var ColorName = $basketButton.attr("data-colorname");
        var ProductAmount = $basketButton.attr("data-productamount").replace(',', '.');
        var TotalQuantity = $("#data-quantity").val();

        //var ListPosition = $basketButton.attr("data-listposition");

        var CatName = $("#data-CatName").val();

        //var brandName = $("#data-brandName").val();

        var CatID = $basketButton.attr('data-CatID');

        var catName1 = $('#catName1').val();
        var catName2 = $('#catName2').val();

        if (!UserID || UserID == "0")
            UserID = "unknown";

        if (SizeID != undefined && ColorID != undefined && ProductID != undefined && SizeID != "" && ColorID != "" && ProductID != "") {
            var NormalText = $basketButton.text();
            var AddingText = $basketButton.attr("data-adding");
            $basketButton.text(AddingText);

            var AddToCartId = ProductCode + "-R" + ColorCode;

            //alert(AddToCartId);

            var data = 'sizeID=' + SizeID + "&colorID=" + ColorID + "&productID=" + ProductID + "&adet=" + Amount + "&langID=" + LangID;

            GenerateLocalLoading($(".ProductDetail.Combines"), "show");
            AddToCard(data, function (dt) {
                $basketButton.text(NormalText);

                if (dt.Sonuc == true) {

                    (rtbhEvents = window.rtbhEvents || []).push(
                        {
                            eventType: 'basketadd',
                            offerId: AddToCartId
                        },
                        {
                            eventType: 'uid',
                            id: UserID
                        }
                    );

                    //sepete ekle gtag
                    dataLayer.push({ ecommerce: null }); // clear the previous ecommerce object.
                    dataLayer.push({
                        event: "ecom_event",
                        event_category: "ecommerce",
                        event_action: "add_to_cart",
                        ecommerce: {
                            items: [{
                                item_id: AddToCartId, //Type: String
                                item_group_id: ProductCode, //Type: String
                                item_name: ProductName, //Type: String
                                currency: "TRY", //Type: String
                                discount: null, //Type: Float
                                index: 1, //Type: Integer, Desciption: Position in the list
                                item_brand: "BSL", //Type: String
                                item_category: catName1, //Type: String, Description: Main category of the product
                                item_category2: catName2, //Type: String, Description: Type of the product
                                item_list_id: CatID, //Type: String
                                item_list_name: null, //Type: String
                                item_variant: null, //Type: String, Description: Size
                                item_size: null, //Type: String
                                item_color: ColorName, //Type: String
                                price: parseFloat(ProductAmount), //Type: Float
                                quantity: 1, //Type: Integer
                                stock: parseInt(TotalQuantity)
                            }]
                        }
                    });

                    GetSepetIcerik(function (dt) {
                        $("#UserAndBasket").html(dt);

                        if ($(window).width() > 991) {
                            toggleBasket();
                        }

                        BasketAddMessage();
                    });
                }
                else {
                    SwalGenerate("error", dt.IslemSonucAciklama, "İşlem Başarısız", "Kapat");
                }

                GenerateLocalLoading($(".ProductDetail.Combines"), "hide");
            });
        }
        else {
            if (SizeID == undefined || SizeID == "") {
                $("#PrdBlackBg").show();
                $(".SizeOptions").addClass("PleaseSelect");
                $(".AddToBasket").addClass("PleaseSelect");

                setTimeout(function () {
                    $(".ProductOptions").addClass("PleaseSelectFixedArea");
                }, 500);

                if ($(window).width() > 767) {
                    $(".ProductOptions").css("position", "unset");
                    $("body").css("overflow", "hidden");
                }

                var OptionAreaScrollTop = 0;
                if ($(window).width() < 767) {
                    OptionAreaScrollTop = $(".SizeOptions").offset().top - 250;
                }

                $('html, body').animate({
                    scrollTop: OptionAreaScrollTop
                }, 500);

                if ($(".AutoTextRep").length > 0) {
                    $(".AddToBasket button").attr("data-first", $(".AddToBasket button").text());
                    $(".AddToBasket button").text($('#BedenSec').val());

                    $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }
            }

            if (ColorID == undefined || ColorID == "") {
                alert(RenkSec);

                $(".AddToBasket button").attr("data-first", $(".AddToBasket button").text());
                $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());

                if ($(".AutoTextRep").length > 0) {
                    $(".AddToBasket button").text($('#BedenSec').val());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }
            }

            if (ProductID == undefined || ProductID == "") alert(UrunYok);
        }

        e.preventDefault();
        return false;
    });

    //Ürün Beden Seçimi
    $('.SizeOptions .selectSize:not(.NotifyWhen)').live("click", function () {
        var dataId = $(this).find('a').attr('data-id');
        $(this).parents(".Sizes").find("#SizeID").val(dataId);

        $(this).parents(".SizeOptions").find("a").removeClass("active");
        $(this).parents(".SizeOptions").find("span").removeClass("active");
        $(this).addClass("active");
        $(this).parent().addClass("active");

        if ($(".NewPD").length > 0) {
            $(".SizeOptions, .SizeAndAmount span.ChooseTitle").addClass("passed");
            $(".Colors span.ChooseTitle").removeClass("current");
            $(".Colors span.ChooseTitle").addClass("passed");

            $(".Sizes span.ChooseTitle").removeClass("current");
            $(".Sizes span.ChooseTitle").addClass("passed");

            $(".SizeAndAmount  > span.ChooseTitle").removeClass("current");
            $(".SizeAndAmount  > span.ChooseTitle").addClass("passed");

            $(".AmountOptions  span.ChooseTitle").removeClass("passed");
            $(".AmountOptions  span.ChooseTitle").addClass("current");

            var TrigAddBasket = false;

            if ($(".SizeOptions.PleaseSelect").length == 1) {
                TrigAddBasket = true;
            }

            $(".AddToBasket button").removeClass("NotSelected");

            if ($(".AutoTextRep").length > 0 && $(".AddToBasket button").attr("data-first") != undefined && $(".AddToBasket button").attr("data-first").length > 0 && $(".EsPD").length <= 0) {
                $(".AddToBasket button").text($(".AddToBasket button").attr("data-first"));
            }

            $(".SizeOptions").removeClass("PleaseSelect");
            $(".AddToBasket").removeClass("PleaseSelect");
            $(".ProductOptions").removeClass("PleaseSelectFixedArea");

            $("#PrdBlackBg").hide();

            if (TrigAddBasket) {
                $(".AddToBasket #Basket").click();
            }
        }

        if ($(".LastProducts").length > 0) {
            var params = "ProductID=" + $("#ProductID").val() + "&ColorID=" + $("#ColorID").val() + "&SizeID=" + $("#SizeID").val();
            GetProductWarn(params);
        }
    });

    // Renk Değişimi
    $("#changeColor").live("click", function (e) {
        var LangID = $("#LangID").val();
        var ProductID = $(this).attr("data-productID");
        var ColorID = $(this).attr("data-id");
        button = $(this);

        ChangeProductColor(ProductID, ColorID, LangID, button);
    });

    // Favorilere Ekleme
    $(".passiveFavorite").live("click", function () {
        var ColorID = $("#ColorID").val();
        var ProductID = $("#ProductID").val();
        var button = $(this);

        if (ColorID && ProductID) {
            var OverlayElement = $(".ProductDetail");
            if ($(window).width() < 992)
                OverlayElement = $(".BasktButtons");

            GenerateLocalLoading(OverlayElement, "show");

            AddToFavorite(ColorID, ProductID, function (status, msg) {
                if (status) {

                    var UserID = $("#UserID").val();
                    var ProductName = $('#ProductName').val();

                    var CatalogName = $('#CatalogName').val();

                    var CatalogId = $('#CatalogId').val();
                    var Amount = $('#ForMemberCardAmount').val().replace(',', '.');
                    var ColorName = $('#ColorName').val();

                    var Quantity = $('#Quantityyy').val();

                    var ProductCode = $('#DatalayerProductCode').val();
                    var ColorCode = $('#DatalayerColorCode').val();

                    var AddToCartId = ProductCode + "-R" + ColorCode;

                    var catName1 = $('#catName1').val();
                    var catName2 = $('#catName2').val();

                    //gtag script
                    dataLayer.push({ ecommerce: null }); // clear the previous ecommerce object.
                    dataLayer.push({
                        event: "ecom_event",
                        event_category: "ecommerce",
                        event_action: "add_to_wishlist",
                        ecommerce: {
                            items: [{
                                item_id: AddToCartId, //Type: String
                                item_group_id: ProductCode, //Type: String
                                item_name: ProductName, //Type: String
                                currency: "TRY", //Type: String
                                discount: null, //Type: Float
                                index: 1, //Type: Integer, Desciption: Position in the list
                                item_brand: "BSL", //Type: String
                                item_category: catName1, //Type: String, Description: Main category of the product
                                item_category2: catName2, //Type: String, Description: Type of the product
                                item_list_id: CatalogId, //Type: String
                                item_list_name: null, //Type: String
                                item_variant: null, //Type: String, Description: Size
                                item_size: null, //Type: String
                                item_color: ColorName, //Type: String
                                price: parseFloat(Amount), //Type: Float
                                quantity: 1, //Type: Integer
                                stock: parseInt(Quantity)
                            }]
                        }
                    });

                    //RTB house script
                    (rtbhEvents = window.rtbhEvents || []).push(
                        {
                            eventType: 'wishlist',
                            offerId: ProductCode
                        },
                        {
                            eventType: 'uid',
                            id: UserID
                        }
                    );

                    button.addClass("activeFavorite");
                    button.removeClass("passiveFavorite");
                    button.find(".sorsfont").removeClass("sorsfont-follow").addClass("sorsfont-added-follow");
                    SwalGenerate("success", msg, "İşlem Başarılı", "Kapat");
                }
                else {
                    SwalGenerate("warning", msg, "İşlem Başarısız", "Kapat");
                }

                GenerateLocalLoading(OverlayElement, "hide");
            });
        }
    });

    // Favorilerden Çıkarma
    $(".activeFavorite").live("click", function () {
        var ProductID = $("#ProductID").val();
        var button = $(this);

        if (ProductID) {
            var OverlayElement = $(".ProductDetail");
            if ($(window).width() < 992)
                OverlayElement = $(".BasktButtons");

            GenerateLocalLoading(OverlayElement, "show");

            removeFavorite(ProductID, function (status) {
                if (status) {
                    button.addClass("passiveFavorite");
                    button.removeClass("activeFavorite");
                    button.find(".sorsfont").removeClass("sorsfont-added-follow").addClass("sorsfont-follow");
                    SwalGenerate("success", "Ürün favorilerinizden çıkarılmıştır.", "İşlem Başarılı", "Kapat");
                }
                else {
                    SwalGenerate("warning", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!", "İşlem Başarısız", "Kapat");
                }

                GenerateLocalLoading(OverlayElement, "hide");
            });
        }
    });

    // Stoğa Gelince Haber Ver Modal
    $("a.NotifyWhen").live("click", function myfunction() {
        var ProductID = $("#ProductID:first").val();
        var ColorID = $("#ColorID").val();
        var SizeID = $(this).parent().parent().parent().find("input[name=SizeIDs]").val();

        if (ProductID != "" && ProductID != null && ProductID != undefined && typeof ProductID !== 'undefined' && ColorID != null && ColorID != "" && ColorID != undefined && SizeID != null && SizeID != "" && SizeID != undefined) {
            var params = "ProductID=" + ProductID + "&ColorID=" + ColorID + "&SizeID=" + SizeID;
            GetListForRemind(params);
        }
    });

    // Stoğa Gelince Haber Action
    $("#NotifyModal #RemindMeLater.active").live("click", function myfunction() {
        var StockIDs = "?x=";
        var curVal = 0;

        $(".NotiyfyRow .OutOfStockRemind").each(function (index) {
            StockIDs += "&[" + curVal + "].StockID=" + $(this).attr("data-StockID");
            StockIDs += "&[" + curVal + "].SizeID=" + $(this).attr("data-sizeID");
            StockIDs += "&[" + curVal + "].ProductID=" + $(this).attr("data-ProductID");
            StockIDs += "&[" + curVal + "].ProductCode=" + $(this).attr("data-ProductCode");
            StockIDs += "&[" + curVal + "].ColorID=" + $(this).attr("data-colorid");

            curVal++;
        });

        var name = $('input[name="NameModal"]').val();
        var username = $('input[name="UserNameModal"]').val();

        var gsm = $('input[name="GsmModal"]').val();
        var gsmLen = 0;

        if (gsm != "" && gsm != null) {
            gsmLen = gsm.length;
        }

        var kvkk = $('input[name="KVKKModal"]').prop("checked");

        if (kvkk == true && name != null && username != null && name != "" && username != "" && gsm != "") {
            if (gsmLen < 10) {
                SwalGenerate("error", "Lütfen gerçerli bir GSM numarası giriniz.", "İşlem Başarısız", "Tekrar Dene");
            }
            else {
                var param = StockIDs + "&Name=" + name + "&UserName=" + username + "&Gsm=" + gsm + "&kvkk=" + kvkk;

                RemindMeWhenAvailable(param);
            }
        }
        else {
            SwalGenerate("warning", "Lütfen Tüm Alanları Doldurunuz.", "İşlem Başarısız", "Tekrar Dene");
        }

        return false;
    });
    // To Operations

    // Slider Setting
    $('.ProductDetailImages ul').on('afterChange', function (event, slick, currentSlide, nextSlide) {
        $(".SmallProductImages ul li").each(function () {
            if ($(this).data("slick-index") == currentSlide) {
                $("img", this).addClass("Selected");
            }
            else {
                $("img", this).removeClass("Selected");
            }
        });
    });

    // Image Zoom
    $().fancybox({
        selector: '.fancybox'
    });

    // Open SizeTable Modal
    $(".SizeTable").live("click", function () {
        $("#SizeTable").modal();
    });

    // Backdrop Setting
    $("body #PrdBlackBg").on("click", function (e) {
        $("#PrdBlackBg").hide();
        $(".SizeOptions.open").removeClass("PleaseSelect");
        $(".SizeOptions, .CombineSizeOptions").removeClass("PleaseSelect");
        $(".AddToBasket.PleaseSelect").removeClass("PleaseSelect");

        $(".ProductOptions").removeClass("PleaseSelectFixedArea");
        if ($(".AutoTextRep").length > 0) {
            $(".AutoTextRep button").text($(".AutoTextRep button").attr("data-first"));
        }

        if ($(window).width() > 767) {
            $("body").css("overflow", "unset");
        }
    });

    if ($(".SizeOptions .ONE.SIZE").length > 0) {
        $(".SizeOptions .ONE.SIZE").trigger("click");
    }
});